// components/dummyData.js

const dummyData = [
  {
    title: "Kindergarten",
    classes: [
      {
        title: "Baby Class",
        subjects: ["Drawing", "Singing", "Colors", "Play Activities", "Listening Skills"],
      },
      {
        title: "Middle Class",
        subjects: ["Numbers", "Letters", "Coloring", "Storytelling", "Motor Skills"],
      },
      {
        title: "Top Class",
        subjects: ["Basic Math", "Reading", "Writing", "Songs", "Nature Study"],
      },
    ],
  },
  {
    title: "Primary",
    classes: [
      {
        title: "Standard 1",
        subjects: ["Kiswahili", "English", "Mathematics", "Science & Technology", "Civics & Moral Education", "Vocational Skills"],
      },
      {
        title: "Standard 2",
        subjects: ["Kiswahili", "English", "Mathematics", "Science & Technology", "Civics & Moral Education", "Vocational Skills"],
      },
      {
        title: "Standard 3",
        subjects: ["Kiswahili", "English", "Mathematics", "Science", "Civics", "Social Studies", "ICT", "Vocational Skills", "Life Skills"],
      },
      {
        title: "Standard 4",
        subjects: ["Kiswahili", "English", "Mathematics", "Science", "Civics", "Social Studies", "ICT", "Vocational Skills", "Life Skills"],
      },
      {
        title: "Standard 5",
        subjects: ["Kiswahili", "English", "Mathematics", "Science", "Civics", "Social Studies", "ICT", "Vocational Skills", "Life Skills"],
      },
      {
        title: "Standard 6",
        subjects: ["Kiswahili", "English", "Mathematics", "Science", "Civics", "Social Studies", "ICT", "Vocational Skills", "Life Skills"],
      },
      {
        title: "Standard 7",
        subjects: ["Kiswahili", "English", "Mathematics", "Science", "Civics", "Social Studies", "ICT", "Vocational Skills", "Life Skills"],
      },
    ],
  },
  {
    title: "Secondary O-Level",
    classes: [
      {
        title: "Form 1",
        subjects: ["Kiswahili", "English", "Mathematics", "Biology", "Civics", "Geography", "History", "Physics", "Chemistry", "Bookkeeping", "Commerce", "Information and Computer Studies"],
      },
      {
        title: "Form 2",
        subjects: ["Kiswahili", "English", "Mathematics", "Biology", "Civics", "Geography", "History", "Physics", "Chemistry", "Bookkeeping", "Commerce", "Information and Computer Studies"],
      },
      {
        title: "Form 3",
        subjects: ["Kiswahili", "English", "Mathematics", "Biology", "Civics", "Geography", "History", "Physics", "Chemistry", "Bookkeeping", "Commerce", "Information and Computer Studies", "Agriculture", "Food and Nutrition", "Technical Drawing", "Music", "French"],
      },
      {
        title: "Form 4",
        subjects: ["Kiswahili", "English", "Mathematics", "Biology", "Civics", "Geography", "History", "Physics", "Chemistry", "Bookkeeping", "Commerce", "Information and Computer Studies", "Agriculture", "Food and Nutrition", "Technical Drawing", "Music", "French"],
      },
    ],
  },
  {
    title: "Secondary A-Level",
    classes: [
      {
        title: "Form 5",
        subjects: ["Physics", "Chemistry", "Biology", "Advanced Mathematics", "Geography", "Economics", "History", "Kiswahili", "English Language", "Literature", "General Studies", "Agriculture", "Accountancy", "Commerce", "ICT"],
      },
      {
        title: "Form 6",
        subjects: ["Physics", "Chemistry", "Biology", "Advanced Mathematics", "Geography", "Economics", "History", "Kiswahili", "English Language", "Literature", "General Studies", "Agriculture", "Accountancy", "Commerce", "ICT"],
      },
    ],
  },
];

export default dummyData;
